import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import { Button, Form, Col, Row, Modal } from 'react-bootstrap';
import { Buffer } from 'buffer';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import $ from 'jquery';

function CspIme() {
  const navigate = useNavigate();
  const [query, setQuery] = useState("");
  const [suggestions, setSuggestions] = useState(false);
  const [documentLists, setDocumentLists] = useState(false);
  const [userData, setUserData] = useState("");
  const currentUser = useSelector((state) => state.data);
  const [errors, setErrors] = useState(false);
  const [data, setData] = useState(false);
  const [staticData, setStaticData] = useState(false);
  const [bankList, setBankList] = useState(false);
  const [bankBranchList, setBankBranchList] = useState(false);
  const [bankList1, setBankList1] = useState(false);
  const [hasWeekendOff, setHasWeekendOff] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showCSPOnboarding, setShowCSPOnboarding] = useState(false);
  const [addCSP, setAddCSP] = useState(false);
  const [cspResponse, setCspResponse] = useState(false);
  const [localStates, setLocalStates] = useState(false);
  const [localDistricts, setLocalDistricts] = useState(false);
  const [shopStates, setShopStates] = useState(false);
  const [shopDistricts, setShopDistricts] = useState(false);
  const [localCity, setLocalCity] = useState(false);
  const [shopCity, setShopCity] = useState(false);
  const [courseData, setCourseData] = useState(false);

  const handleClose = () => {
    setShowModal(false);
    setShowCSPOnboarding(false);
    setAddCSP(false);
    setErrors(false);
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    let jsonData = {};
    let errorData = {};
    Array.from(form.elements).forEach((item) => {
      if (item.name) {
        if (item.value == "" && item.getAttribute("requiredField")) {
          errorData[item.name] = [addSpaceBetweenCases(item.name)] + " is required";
        }
        jsonData[item.name] = item.value;
      }
    });
    if (Object.entries(errorData).length > 0) {
      setErrors(errorData);
    }
    else {
      try {
        const response = await axios.post('/ime/csp/generateOTT', { ...jsonData, cspCode: userData?.ime_csp_code_kyc });
        const { Response, Url } = response.data;
        if (Response.Code == "0") {
          window.open(Url, '_blank');
        }
        else {
          //window.location.href = "";
        }
      } catch (error) {
        if (error?.response?.data?.message) {
          toast(error.response.data.message);
        }
      }
    }
  };

  const onboardCSPSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    let jsonData = {};
    let errorData = {};
    Array.from(form.elements).forEach((item) => {
      if (item.name) {
        if (item.value == "" && item.getAttribute("requiredField")) {
          errorData[item.name] = [addSpaceBetweenCases(item.name)] + " is required";
        }
        jsonData[item.name] = item.value;
      }
    });
    if (Object.entries(errorData).length > 0) {
      setErrors(errorData);
    }
    else {
      try {
        const response = await axios.post('/ime/csp/onboarding', { ...jsonData, cspCode: userData?.ime_csp_code_kyc });
        const { Response } = response.data;
        if (Response.Code == "0") {
          //toast(Response.Message);
        }
        else {
          //window.location.href = "";
        }
        toast(Response.Message);
      } catch (error) {
        if (error?.response?.data?.message) {
          toast(error.response.data.message);
        }
      }
    }
  };

  const createCSPSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    let jsonData = {};
    let errorData = {};
    Array.from(form.elements).forEach((item) => {
      if (item.name) {
        if (item.value == "" && item.getAttribute("requiredField")) {
          errorData[item.name] = [addSpaceBetweenCases(item.name)] + " is required";
        }
        jsonData[item.name] = item.value;
      }
    });
    if (Object.entries(errorData).length > 0) {
      setErrors(errorData);
    }
    else {
      try {
        const response = await axios.post('/ime/csp/create', { ...jsonData, user_id: userData?._id });
        const { Response } = response.data;
        if (Response.Code == "0") {
          toast(Response.Message);
          handleClose();
        }
        else {
          toast(Response.Message);
          //window.location.href = "";
        }
      } catch (error) {
        if (error?.response?.data?.message) {
          toast(error.response.data.message);
        }
      }
    }
  };

  const handleCheck = async (e) => {
    e.preventDefault();
    try {
      let response = await axios.post("/ime/csp/getEntityStatus", { cspCode: userData?.ime_csp_code_kyc });
      let { Response, Status, IsEligibleForTxn } = response.data;
      if (Response.Code == "0") {
        if (Status == "OttToken") {
          setShowModal(true);
        }
        else if (Status == "RBLUniqueIdentifier") {
          let response = await axios.post("/ime/csp/getUniqueId", { cspCode: userData?.ime_csp_code_kyc });
          let { Response } = response.data;
          if (Response.Code == "0") {
            captureFinger();
          }
          else {
            setShowModal(true);
          }
        }
        else if (Status == "BioKyc") {
          captureFinger();
        }
        else if (Status == "CSPOnboarding") {
          setShowCSPOnboarding(true);
        }
        else if (Status == "Success" && IsEligibleForTxn == "") {
          let response = await axios.post("/ime/csp/consent", { cspCode: userData?.ime_csp_code_kyc });
          let { Remarks, Response } = response.data;
          if (Remarks == "OTP Consent Pending") {
            window.open("https://uid.rbl.bank.in/CustomerLogin/PPIAgentEkyc.aspx?ref=Xv5MN5UJSFNAfOlBagr4oQ==", '_blank');
          }
          else {
            toast(Response.Message);
          }
        }
        else if (IsEligibleForTxn == "True") {
          toast("You are eligible for transaction!");
        }
        else {
          //toast(ResponseMessage);
        }
      }
      else {
        toast(Response.Message);
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  const handleSearch = async (e) => {
    e.preventDefault();
    try {
      let response = await axios.post("/ime/csp/check", { user_id: userData?._id, cspCode: userData?.ime_csp_code_kyc });
      let { Response } = response.data;
      setCspResponse(response.data);
      getDocuments();
      getStaticData1();
      getStaticData2();
      toast(Response.Message);
    } catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  const getDocuments = async () => {
    axios.post(`/v2/imeremittance/get/document/list`, { user_id: userData?._id }).then((res) => {
      setDocumentLists(res.data.data); // Adjust to your API response
    }).catch(() => {
      setDocumentLists(false);
    });
  };

  const encode = (input) => {
    const bytes = new TextEncoder().encode(input);
    const binary = Array.from(bytes).map(b => String.fromCharCode(b)).join('');
    return btoa(binary);
  };

  const captureFinger = async () => {
    const finalUrl = "https://127.0.0.1:11100/rd/capture";
    const XML = `<?xml version="1.0"?><PidOptions ver="1.0"><Opts fCount="1" fType="2" iCount="0" pCount="0" pgCount="2" format="0" pidVer="2.0" timeout="10000" pTimeout="20000" wadh="TF/lfPuh1n4ZY1xizYpqikIBm+gv65r51MFNek4uwNw=" posh="UNKNOWN" env="P" /> <CustOpts><Param name="mantrakey" value="" /></CustOpts> </PidOptions>`;
    //const XML = `<?xml version="1.0"?><PidOptions ver="1.0"><Opts fCount="1" fType="2" iCount="0" iType="0" pCount="0" pType="0" format="0" pidVer="2.0" timeout="10000" otp="" wadh="TF/lfPuh1n4ZY1xizYpqikIBm+gv65r51MFNek4uwNw=" posh="" env="PP" /><CustOpts><Param name="" value="" /></CustOpts></PidOptions>`;
    try {
      $.ajax({
        type: "CAPTURE",
        async: false,
        crossDomain: true,
        url: finalUrl,
        data: XML,
        contentType: "text/xml; charset=utf-8",
        processData: false,
        success: async function (resData) {
          //var pid = Buffer.from(resData, 'utf-8').toString('base64');
          var pid = encode(resData);
          try {
            let response = await axios.post('/ime/csp/enrollment', { cspCode: userData?.ime_csp_code_kyc, pid });
            const { status, message } = response.data;
            if (!status) {
              toast(message);
            }
            else {
              toast(message);
            }
          }
          catch (error) {
            if (error?.response?.data?.message) {
              toast(error.response.data.message);
            }
          }
        },
        error: function (jqXHR, ajaxOptions, thrownError) {
          toast(getHttpError(jqXHR));
        },
      });
    } catch (error) {
      toast(getHttpError(error));
    }
  };

  const getHttpError = (error) => {
    let err = "Unhandled Exception";
    if (!error.response) {
      err = 'Service Unavailable';
    } else if (error.response.status === 404) {
      err = 'Requested page not found';
    } else if (error.response.status === 500) {
      err = 'Internal Server Error';
    } else if (error.message === 'timeout') {
      err = 'Time out error';
    } else if (error.message === 'abort') {
      err = 'Ajax request aborted';
    } else {
      err = 'Unhandled Error';
    }
    return err;
  };

  function addSpaceBetweenCases(str) {
    return str.replace(/([a-z])([A-Z])/g, '$1 $2');
  };
  const deleteError = async (e) => {
    const errorKey = e.target.name;
    if (errorKey) {
      if (errorKey == "bank_name") {
        let bankId = e.target.value;
        let reqData = {
          TypeCode: "WSST-BBLV1",
          ReferenceValue: bankId,
          cspCode: userData?.ime_csp_code_kyc
        };
        let response = await axios.post('/ime/get/static/data', reqData);
        const { DataList } = response.data;
        setBankBranchList(DataList != null ? DataList.Data : false);
      }
      if (errorKey == "HasWeekendOff") {
        setHasWeekendOff(e.target.value);
      }
      const updatedErrors = { ...errors };
      delete updatedErrors[errorKey];
      setErrors(updatedErrors);
      setData({ ...data, [e.target.name]: e.target.value });
    }
  };

  const getStaticData1 = async () => {
    let reqData = {
      TypeCode: "WSST-OBAV1",
      cspCode: userData?.ime_csp_code_kyc
    };
    let response = await axios.post('/ime/get/static/data', reqData);
    const { DataList } = response.data;
    setStaticData(DataList != null ? DataList.Data : false);
  };

  const getStaticData2 = async () => {
    let reqData = {
      TypeCode: "WSST-BBAV1",
      ReferenceValue: staticData?.[0]?.Id,
      cspCode: userData?.ime_csp_code_kyc
    };
    let response = await axios.post('/ime/get/static/data', reqData);
    const { DataList } = response.data;
    setBankList(DataList != null ? DataList.Data : false);
  };

  const getStaticData3 = async () => {
    let response = await axios.post('/ime/get/static/bank');
    const { DataList } = response.data;
    setBankList1(DataList != null ? DataList.Data : false);
  };

  useEffect(() => {
    if (currentUser && currentUser.prabhuCspOnboarding == false) {
      navigate('/admin/dashboard');
    }
    else {
      //getStaticData1();
      //getStaticData2();
      getStaticData3();
    }
  }, [currentUser]);

  const getLocalStateData = async (e) => {
    deleteError(e);
    try {
      const response = await axios.post('/v2/imeremittance/get/state', { country_id: e.target.value });
      const { status } = response.data;
      if (status) {
        if (e.target.name == "Country") {
          setLocalStates(response.data.data);
        }
        else {
          setShopStates(response.data.data);
        }
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  const getLocalDistrictData = async (e) => {
    deleteError(e);
    try {
      const response = await axios.post('/v2/imeremittance/get/district', { state_id: e.target.value });
      const { status } = response.data;
      if (status) {
        if (e.target.name == "State") {
          setLocalDistricts(response.data.data);
        }
        else {
          setShopDistricts(response.data.data);
        }
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  const getLocalCity = (e) => {
    deleteError(e);
    if (e.target.name == "District") {
      setLocalCity(e.target.options[e.target.selectedIndex].text);
    }
    else {
      setShopCity(e.target.options[e.target.selectedIndex].text);
    }
  };

  useEffect(() => {
    if (query.length < 2) {
      setSuggestions(false);
      setUserData("");
      return;
    }
    axios.get(`/users/search?q=${encodeURIComponent(query)}`).then((res) => {
      setSuggestions(res.data.users); // Adjust to your API response
    }).catch(() => {
      setSuggestions(false);
    });
  }, [query]);

  const uploadDocument = (e, id) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = async () => {
        const base64String = reader.result;
        //setBase64(base64String);
        const response = await axios.post('/v2/imeremittance/csp/upload/document', { id, user_id: userData?._id, document: base64String });
        const { status } = response.data;
        if (status) {
          if (e.target.name == "State") {
            setLocalDistricts(response.data.data);
          }
          else {
            setShopDistricts(response.data.data);
          }
        }
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <div class="content-wrapper">
      <div class="row">
        <div class="col-lg-12 grid-margin stretch-card">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">
                Search Sender
              </h4>
              <form className="searchForm" >
                <div className="row">
                  <div class="col-lg-3 col-md-3">
                    <label>User</label>
                    <input
                      type="text"
                      class="form-control"
                      value={query}
                      onChange={(e) => setQuery(e.target.value)}
                      placeholder="Type to search..."
                    />

                    {suggestions && suggestions.length > 0 && (
                      <ul
                        style={{
                          border: "1px solid #ccc",
                          marginTop: 0,
                          paddingLeft: 0,
                          listStyleType: "none",
                          maxHeight: 150,
                          overflowY: "auto",
                          cursor: "pointer",
                        }}
                      >
                        {suggestions.map((item, idx) => (
                          <li
                            key={idx}
                            style={{ padding: "8px", borderBottom: "1px solid #eee" }}
                            onClick={() => {
                              setQuery(item.name + "(" + item.mobile + ")"); // Adjust as per your data structure
                              setUserData(item);
                              setSuggestions(false);
                            }}
                          >
                            {item.name + "(" + item.mobile + ")"}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                  <div class="col-lg-3 col-md-3">
                    <input type="button" className="search-btn btn btn-primary" value="Search CSP" onClick={handleSearch} />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="col-lg-12 grid-margin stretch-card">
          <div class="card">
            <div class="card-body">
              {
                cspResponse && (
                  cspResponse?.Response?.Code == 0 ? (
                    <>
                      <h4 class="card-title">
                        CSP Data
                      </h4>
                      <ul className="showData">
                        {Object.entries(cspResponse.CompanyDetails).map(([key, value]) => (
                          (value != "" && value != null) && (
                            <li key={key}>
                              <strong>{addSpaceBetweenCases(key)}:</strong>
                              <div>{value}</div>
                            </li>
                          )
                        ))}
                        <li>
                          <strong>Owner Name:</strong>
                          <div>{cspResponse.AdditionalDetails.OwnerDetails.OwnerDetailsInfo[0].OwnerName}</div>
                        </li>
                        <li>
                          <strong>Bank Name:</strong>
                          <div>{cspResponse.AdditionalDetails.BankDetails.BankDetailsInfo[0].BankName}</div>
                        </li>
                      </ul>
                      {
                        documentLists && (
                          <>
                            <hr />
                            <h4 class="card-title">
                              Documents
                            </h4>
                            <table className="table">
                              <tr>
                                <th>Sr.No.</th>
                                <th>Document Image</th>
                                <th>Document</th>
                                <th>Status</th>
                                <th>Action</th>
                              </tr>
                              {documentLists.map((list, index) => (
                                <tr>
                                  <td>{index + 1}</td>
                                  <td><img src={`${process.env.REACT_APP_BACKEND_URL}/${list.file_path}`} width="50px" /></td>
                                  <td>{list.document.value}</td>
                                  <td>{list.status}</td>
                                  <td><input className="form-control" type="file" onChange={(e) => uploadDocument(e, list._id)} /></td>
                                </tr>
                              ))}
                            </table>
                          </>
                        )
                      }
                      <hr />
                      <div class="col-lg-12">
                        <input type="button" className="btn btn-primary" value="Check CSP" onClick={handleCheck} />
                      </div>
                    </>
                  ) : userData != "" ? (
                    <>
                      <input type="button" className="btn btn-primary" value="Add CSP" onClick={(e) => setAddCSP(true)} />
                    </>
                  ) : (
                    <></>
                  )
                )
              }
            </div>
          </div>
        </div>
      </div>
      {/* Modal component */}
      <Modal show={showModal} onHide={handleClose} centered backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Create New CSP</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <div class="row justify-content-center">
              <div class="col-md-12">
                <div className="row">
                  <div class="col-lg-12 col-md-12">
                    <label>Select User</label>
                    <select class="form-control" name="user" value={data?.user} onChange={deleteError} requiredField="true">
                      <option value="">--Select--</option>
                      {staticData && staticData.map((data) => (
                        <option value={data.Id}>{data.Value}</option>
                      ))}
                    </select>
                    <span className="error">{errors && errors?.user}</span>
                  </div>
                  <div class="col-lg-12 col-md-12">
                    <button class="search-btn btn btn-primary" type="submit">{"Create CSP"}</button>
                  </div>
                </div>
              </div>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      <Modal show={showCSPOnboarding} onHide={handleClose} centered size={'xl'} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Onboarding CSP</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={onboardCSPSubmit}>
            <div class="row justify-content-center">
              <div class="col-md-12">
                <div className="row">
                  <div class="col-lg-4 col-md-4">
                    <label>Account Number</label>
                    <input class="form-control" type="text" name="account_number" onChange={deleteError} requiredField="true" />
                    <span className="error">{errors && errors?.account_number}</span>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>Agent Account Name</label>
                    <input class="form-control" name="agent_account_name" onChange={deleteError} requiredField="true" />
                    <span className="error">{errors && errors?.agent_account_name}</span>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>IFSC Code</label>
                    <input class="form-control" name="ifsc_code" onChange={deleteError} requiredField="true" />
                    <span className="error">{errors && errors?.ifsc_code}</span>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>Bank Name</label>
                    <select class="form-control" name="bank_name" onChange={deleteError} requiredField="true">
                      <option value="">--Select--</option>
                      {bankList && bankList.map((data) => (
                        <option value={data.Value}>{data.Value}</option>
                      ))}
                    </select>
                    <span className="error">{errors && errors?.bank_name}</span>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>Branch Name</label>
                    <input className="form-control" name="branch_name" onChange={deleteError} requiredField="true" />
                    {/* <select class="form-control" name="branch_name" onChange={deleteError} requiredField="true">
                      <option value="">--Select--</option>
                      {bankBranchList && bankBranchList.map((data) => (
                        <option value={data.Id}>{data.Value}</option>
                      ))}
                    </select> */}
                    <span className="error">{errors && errors?.branch_name}</span>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>Institute Name</label>
                    <input class="form-control" name="institute_name" onChange={deleteError} requiredField="true" />
                    <span className="error">{errors && errors?.institute_name}</span>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>Date Of Passing</label>
                    <input class="form-control" type="date" name="date_of_passing" onChange={deleteError} requiredField="true" />
                    <span className="error">{errors && errors?.date_of_passing}</span>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>Transaction Per Day</label>
                    <input class="form-control" type="number" name="no_of_transaction_per_day" onChange={deleteError} requiredField="true" />
                    <span className="error">{errors && errors?.no_of_transaction_per_day}</span>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>Transfer Amount Per Day</label>
                    <input class="form-control" type="number" name="transfer_amount_per_day" onChange={deleteError} requiredField="true" />
                    <span className="error">{errors && errors?.transfer_amount_per_day}</span>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>Settlement Days</label>
                    <input class="form-control" type="number" name="settlement_days" onChange={deleteError} requiredField="true" />
                    <span className="error">{errors && errors?.settlement_days}</span>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>Expected Annual Turnover</label>
                    <input class="form-control" type="number" name="expected_annual_turnover" onChange={deleteError} requiredField="true" />
                    <span className="error">{errors && errors?.expected_annual_turnover}</span>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>Expected Annual Income</label>
                    <input class="form-control" type="number" name="expected_annual_income" onChange={deleteError} requiredField="true" />
                    <span className="error">{errors && errors?.expected_annual_income}</span>
                  </div>
                  <div class="col-lg-12 col-md-12">
                    <button class="search-btn btn btn-primary" type="submit">{"Onboard CSP"}</button>
                  </div>
                </div>
              </div>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      <Modal show={addCSP} onHide={handleClose} centered size={'xl'} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Add CSP</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={createCSPSubmit}>
            <div class="row justify-content-center">
              <div class="col-md-12">
                <div className="row">
                  {/* <div class="col-lg-4 col-md-4">
                    <label>Partner CSP Code</label>
                    <input class="form-control" type="text" name="PartnerCSPCode" value={data?.PartnerCSPCode} onChange={deleteError} requiredField="true" />
                    <span className="error">{errors && errors?.PartnerCSPCode}</span>
                  </div> */}
                  <div class="col-lg-4 col-md-4">
                    <label>CSP Name</label>
                    <input class="form-control" type="text" name="CSPName" value={data?.CSPName} onChange={deleteError} requiredField="true" />
                    <span className="error">{errors && errors?.CSPName}</span>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>Registration Type</label>
                    <select class="form-control" name="RegistrationType" value={data?.RegistrationType} onChange={deleteError}>
                      <option value="4501">Proprietorship Firm</option>
                      <option value="4502">Partnership Firm</option>
                      <option value="15203">Company</option>
                    </select>
                    <span className="error">{errors && errors?.RegistrationType}</span>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>Registration Number</label>
                    <input class="form-control" type="text" name="RegistrationNumber" value={data?.RegistrationNumber} onChange={deleteError} requiredField="true" />
                    <span className="error">{errors && errors?.RegistrationNumber}</span>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>Business Type</label>
                    <select class="form-control" name="BusinessType" value={data?.BusinessType} onChange={deleteError} requiredField="true">
                      <option value="6200">Remittance</option>
                      <option value="6201">Commercial Bank</option>
                      <option value="6202">Development Bank</option>
                      <option value="6203">Finance</option>
                      <option value="6204">Cooperative</option>
                      <option value="6205">Travel Agency</option>
                      <option value="6206">Cyber</option>
                    </select>
                    <span className="error">{errors && errors?.BusinessType}</span>
                  </div>
                  {/* <div class="col-lg-4 col-md-4">
                    <label>Contract Expiry Date</label>
                    <input class="form-control" type="date" name="ContractExpiryDate" value={data?.ContractExpiryDate} requiredField="true" readonly />
                    <span className="error">{errors && errors?.ContractExpiryDate}</span>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>Contract Renewal Date</label>
                    <input class="form-control" type="date" name="ContractRenewalDate" value={data?.ContractRenewalDate} onChange={deleteError} requiredField="true" />
                    <span className="error">{errors && errors?.ContractRenewalDate}</span>
                  </div> */}
                  <div class="col-lg-4 col-md-4">
                    <label>PAN Number</label>
                    <input class="form-control" type="text" name="PANNumber" value={data?.PANNumber} onChange={deleteError} requiredField="true" />
                    <span className="error">{errors && errors?.PANNumber}</span>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label>Country</label>
                    <select className="form-control" name="Country" value={data?.Country} onChange={getLocalStateData} requiredField="true">
                      <option value="">--Select--</option>
                      <option value="IND">India</option>
                      <option value="NPL">Nepal</option>
                    </select>
                    <span className="error">{errors && errors?.Country}</span>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>Local State</label>
                    <select class="form-control" name="State" value={data?.State} onChange={getLocalDistrictData} requiredField="true">
                      <option value="">--State--</option>
                      {localStates && localStates.map((state, index) => (
                        <option value={state.state_id}>
                          {state.State}
                        </option>
                      ))}
                    </select>
                    <span className="error">{errors && errors?.State}</span>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>Local District</label>
                    <select class="form-control" name="District" value={data?.District} onChange={getLocalCity} requiredField="true">
                      <option value="">--Select--</option>
                      {localDistricts && localDistricts.map((district, index) => (
                        <option value={district.district_id}>
                          {district.district}
                        </option>
                      ))}
                    </select>
                    <span className="error">{errors && errors?.District}</span>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>Local City</label>
                    <select class="form-control" name="City" value={data?.City} onChange={deleteError} requiredField="true">
                      <option value="">--Select--</option>
                      {localCity && (
                        <option value={localCity}>
                          {localCity}
                        </option>
                      )}
                    </select>
                    <span className="error">{errors && errors?.City}</span>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>House Number</label>
                    <input class="form-control" type="text" name="HouseNumber" value={data?.HouseNumber} onChange={deleteError} requiredField="true" />
                    <span className="error">{errors && errors?.HouseNumber}</span>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>Road Name</label>
                    <input class="form-control" type="text" name="RoadName" value={data?.RoadName} onChange={deleteError} requiredField="true" />
                    <span className="error">{errors && errors?.RoadName}</span>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>Local Pin Code</label>
                    <input class="form-control" type="text" name="PINCode" value={data?.PINCode} onChange={deleteError} requiredField="true" />
                    <span className="error">{errors && errors?.PINCode}</span>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>Address Proof Type</label>
                    <select class="form-control" name="AddressProofType" value={data?.AddressProofType} onChange={deleteError} requiredField="true">
                      <option value="16901">Establishment Certificate</option>
                      <option value="16902">Business License</option>
                      <option value="16903">Electricity Bill</option>
                      <option value="16904">Telephone Bill</option>
                    </select>
                    <span className="error">{errors && errors?.AddressProofType}</span>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>Contact Person Name</label>
                    <input class="form-control" type="text" name="ContactPersonName" value={data?.ContactPersonName} onChange={deleteError} requiredField="true" />
                    <span className="error">{errors && errors?.ContactPersonName}</span>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>Mobile Number 1</label>
                    <input class="form-control" type="text" name="MobileNumber1" value={data?.MobileNumber1} onChange={deleteError} requiredField="true" />
                    <span className="error">{errors && errors?.MobileNumber1}</span>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>Mobile Number 2</label>
                    <input class="form-control" type="text" name="MobileNumber2" value={data?.MobileNumber2} onChange={deleteError} requiredField="true" />
                    <span className="error">{errors && errors?.MobileNumber2}</span>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>Landline Number</label>
                    <input class="form-control" type="text" name="LandlineNumber" value={data?.LandlineNumber} onChange={deleteError} requiredField="true" />
                    <span className="error">{errors && errors?.LandlineNumber}</span>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>Email Id</label>
                    <input class="form-control" type="email" name="Email" value={data?.Email} onChange={deleteError} requiredField="true" />
                    <span className="error">{errors && errors?.Email}</span>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>Bank</label>
                    <select class="form-control" name="Bank" value={data?.Bank} onChange={deleteError} requiredField="true">
                      {bankList1 && bankList1.map((bank, index) => (
                        <option value={bank.Id}>
                          {bank.Value}
                        </option>
                      ))}
                    </select>
                    <span className="error">{errors && errors?.Bank}</span>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>Account Type</label>
                    <select class="form-control" name="AccountType" value={data?.AccountType} onChange={deleteError} requiredField="true">
                      <option value="16201">Current</option>
                      <option value="16202">Personal</option>
                    </select>
                    <span className="error">{errors && errors?.AccountType}</span>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>Account No</label>
                    <input class="form-control" type="text" name="AccountNo" value={data?.AccountNo} onChange={deleteError} requiredField="true" />
                    <span className="error">{errors && errors?.AccountNo}</span>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>IFSC</label>
                    <input class="form-control" type="text" name="IFSC" value={data?.IFSC} onChange={deleteError} requiredField="true" />
                    <span className="error">{errors && errors?.IFSC}</span>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>Device</label>
                    <select class="form-control" name="Device" value={data?.Device} onChange={deleteError} requiredField="true">
                      <option value="16001">Laptop/Desktop</option>
                      <option value="16002">Handheld</option>
                    </select>
                    <span className="error">{errors && errors?.Device}</span>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>Connectivity Type</label>
                    <select class="form-control" name="ConnectivityType" value={data?.ConnectivityType} onChange={deleteError} requiredField="true">
                      <option value="">--Select--</option>
                      <option value="16101">Landline</option>
                      <option value="16102">Mobile</option>
                      <option value="16103">VSAT</option>
                    </select>
                    <span className="error">{errors && errors?.ConnectivityType}</span>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>Provider</label>
                    <select class="form-control" name="Provider" value={data?.Provider} onChange={deleteError} requiredField="true">
                      <option value="">--Select--</option>
                      <option value="Airtel">Airtel</option>
                      <option value="JIO">JIO</option>
                    </select>
                    <span className="error">{errors && errors?.Provider}</span>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>Start Time</label>
                    <input class="form-control" type="time" step="1" name="StartTime" value={data?.StartTime} onChange={deleteError} requiredField="true" />
                    <span className="error">{errors && errors?.StartTime}</span>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>End Time</label>
                    <input class="form-control" type="time" step="1" name="EndTime" value={data?.EndTime} onChange={deleteError} requiredField="true" />
                    <span className="error">{errors && errors?.EndTime}</span>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>Has Weekly Off</label>
                    <select class="form-control" name="HasWeekendOff" value={data?.HasWeekendOff} onChange={deleteError} requiredField="true">
                      <option value="">--Select--</option>
                      <option value="Y">Yes</option>
                      <option value="N">No</option>
                    </select>
                    <span className="error">{errors && errors?.HasWeekendOff}</span>
                  </div>
                  {
                    hasWeekendOff && hasWeekendOff == "Y" && (
                      <div class="col-lg-4 col-md-4">
                        <label>Off Day</label>
                        <input class="form-control" type="number" name="OffDay" value={data?.OffDay} onChange={deleteError} requiredField="true" />
                        <span className="error">{errors && errors?.OffDay}</span>
                      </div>
                    )
                  }
                  <div class="col-lg-4 col-md-4">
                    <label>Owners Name</label>
                    <input class="form-control" name="OwnersName" value={data?.OwnersName} onChange={deleteError} requiredField="true" />
                    <span className="error">{errors && errors?.OwnersName}</span>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>Gender</label>
                    <select class="form-control" name="Gender" value={data?.Gender} onChange={deleteError} requiredField="true">
                      <option value="1801">Male</option>
                      <option value="1802">Female</option>
                      <option value="1803">Third</option>
                    </select>
                    <span className="error">{errors && errors?.Gender}</span>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>DOB</label>
                    <input class="form-control" type="date" name="DOB" value={data?.DOB} onChange={deleteError} requiredField="true" />
                    <span className="error">{errors && errors?.DOB}</span>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>Father Name</label>
                    <input class="form-control" name="FatherName" value={data?.FatherName} onChange={deleteError} requiredField="true" />
                    <span className="error">{errors && errors?.FatherName}</span>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>Mobile Number</label>
                    <input class="form-control" type="number" name="MobileNumber" value={data?.MobileNumber} onChange={deleteError} requiredField="true" />
                    <span className="error">{errors && errors?.MobileNumber}</span>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>Email</label>
                    <input class="form-control" type="email" name="Email1" value={data?.Email1} onChange={deleteError} requiredField="true" />
                    <span className="error">{errors && errors?.Email1}</span>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>Pan Card</label>
                    <input class="form-control" name="PanCard" value={data?.PanCard} onChange={deleteError} requiredField="true" />
                    <span className="error">{errors && errors?.PanCard}</span>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>ID Type</label>
                    <select class="form-control" name="IdType" value={data?.IdType} onChange={deleteError} requiredField="true">
                      <option value="16801">Adhaar Card</option>
                      <option value="16802">Voters Id Card</option>
                      <option value="16803">Driver License</option>
                      <option value="16804">NREGA Card</option>
                      <option value="16805">Passport</option>
                    </select>
                    <span className="error">{errors && errors?.IdType}</span>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>ID Type Number</label>
                    <input class="form-control" name="IDTypeNumber" value={data?.IDTypeNumber} onChange={deleteError} requiredField="true" />
                    <span className="error">{errors && errors?.IDTypeNumber}</span>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label>Country</label>
                    <select className="form-control" name="Country1" value={data?.Country1} onChange={getLocalStateData} requiredField="true">
                      <option value="">--Select--</option>
                      <option value="IND">India</option>
                      <option value="NPL">Nepal</option>
                    </select>
                    <span className="error">{errors && errors?.Country1}</span>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>State</label>
                    <select class="form-control" name="State1" value={data?.State1} onChange={getLocalDistrictData} requiredField="true">
                      <option value="">--State--</option>
                      {shopStates && shopStates.map((state, index) => (
                        <option value={state.state_id}>
                          {state.State}
                        </option>
                      ))}
                    </select>
                    <span className="error">{errors && errors?.State1}</span>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>District</label>
                    <select class="form-control" name="District1" value={data?.District1} onChange={getLocalCity} requiredField="true">
                      <option value="">--Select--</option>
                      {shopDistricts && shopDistricts.map((district, index) => (
                        <option value={district.district_id}>
                          {district.district}
                        </option>
                      ))}
                    </select>
                    <span className="error">{errors && errors?.District1}</span>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>City</label>
                    <select class="form-control" name="City1" value={data?.City1} onChange={deleteError} requiredField="true">
                      <option value="">--Select--</option>
                      {shopCity && (
                        <option value={shopCity}>
                          {shopCity}
                        </option>
                      )}
                    </select>
                    <span className="error">{errors && errors?.City1}</span>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>House Number</label>
                    <input class="form-control" type="text" name="HouseNumber1" value={data?.HouseNumber1} onChange={deleteError} requiredField="true" />
                    <span className="error">{errors && errors?.HouseNumber1}</span>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>Road Name</label>
                    <input class="form-control" type="text" name="RoadName1" value={data?.RoadName1} onChange={deleteError} requiredField="true" />
                    <span className="error">{errors && errors?.RoadName1}</span>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>PIN Code</label>
                    <input class="form-control" type="text" name="PINCode1" value={data?.PINCode1} onChange={deleteError} requiredField="true" />
                    <span className="error">{errors && errors?.PINCode1}</span>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>Residential Address Village Code</label>
                    <input class="form-control" type="text" name="ResidentialAddressVillageCode" value={data?.ResidentialAddressVillageCode} onChange={deleteError} requiredField="true" />
                    <span className="error">{errors && errors?.ResidentialAddressVillageCode}</span>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>Address Proof Type</label>
                    <select class="form-control" type="text" name="AddressProofType1" value={data?.AddressProofType1} onChange={deleteError} requiredField="true">
                      <option value="17101">Adhaar Card</option>
                      <option value="17102">Voters Id Card</option>
                      <option value="17103">Driver License</option>
                      <option value="17104">NREGA Card</option>
                      <option value="17105">Passport Number</option>
                    </select>
                    <span className="error">{errors && errors?.AddressProofType1}</span>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>Educational Qualification</label>
                    <select class="form-control" name="EducationalQualification" value={data?.EducationalQualification} onChange={deleteError} requiredField="true">
                      <option value="16601">Under 10th</option>
                      <option value="16602">10th</option>
                      <option value="16603">12th</option>
                      <option value="16604">Private</option>
                      <option value="16605">Graduate</option>
                      <option value="16606">Post Graduate</option>
                      <option value="16607">Others</option>
                    </select>
                    <span className="error">{errors && errors?.EducationalQualification}</span>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>Additional Course</label>
                    <select class="form-control" name="AdditionalCourse" value={data?.AdditionalCourse} onChange={deleteError} requiredField="true">
                      <option value="16701">IIBF Advance</option>
                      <option value="16702">IIBF Basic Certified By Bank</option>
                      <option value="16703">None</option>
                    </select>
                    <span className="error">{errors && errors?.AdditionalCourse}</span>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>Institute Name</label>
                    <input class="form-control" name="InstituteName" value={data?.InstituteName} onChange={deleteError} requiredField="true" />
                    <span className="error">{errors && errors?.InstituteName}</span>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label>Date of Passed</label>
                    <input class="form-control" type="date" name="DateofPassed" value={data?.DateofPassed} onChange={deleteError} requiredField="true" />
                    <span className="error">{errors && errors?.DateofPassed}</span>
                  </div>
                  <div class="col-lg-12 col-md-12">
                    <button class="search-btn btn btn-primary" type="submit">{"Create CSP"}</button>
                  </div>
                </div>
              </div>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default CspIme;
